import { useNavigate } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';

import { Button } from '@/design-system/primitives';

export function CompleteScreen() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-30 items-start">
      <div className="w-60 h-60 rounded-pill bg-success-wash flex items-center justify-center">
        <CheckCircle2 size={28} strokeWidth={1.5} className="text-success" />
      </div>
      <header>
        <div className="type-label-sm text-ink-muted">You're all set</div>
        <h1 className="type-display-lg mt-10">Your intake is on its way.</h1>
        <p className="type-body-lg text-ink-secondary mt-15 max-w-prose">
          We'll let you know as soon as your clinician has reviewed it. In the
          meantime, explore the portal.
        </p>
      </header>
      <Button onClick={() => navigate('/app', { replace: true })}>
        Enter the portal <ArrowRight size={14} strokeWidth={1.5} />
      </Button>
    </div>
  );
}
